import React from 'react'

export interface AppGeneralContentProps {
  children: React.ReactNode
  className?: string
}

/**
 * AppGeneralContent component that takes maximum available width
 * while the sidebar remains fixed at 255px
 */
export const AppGeneralContent: React.FC<AppGeneralContentProps> = ({ children, className = '' }) => {
  return (
    <div className={`flex-1 min-w-0 min-h-0 overflow-auto ${className}`} style={{ WebkitOverflowScrolling: 'touch' }}>
      {children}
    </div>
  )
}

export default AppGeneralContent
